import { Grid, Typography } from "@mui/material";
import React from "react";

type ScrollToResultButtonProps = {
    title: React.ReactNode;
    count: number;
    scrollToId: string;
} & Omit<React.ComponentPropsWithoutRef<typeof Grid>, "title">;

export function ScrollToResultButton(props: ScrollToResultButtonProps) {
    return (
        <Grid
            container
            item
            justifyContent="space-between"
            alignItems="center"
            paddingInline={2}
            paddingBlock={1}
            borderRadius={1}
            columnGap={2}
            flexWrap="nowrap"
            component="button"
            sx={[
                {
                    cursor: "pointer",
                },
                ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
            ]}
            onClick={() => {
                document.querySelector(`#${props.scrollToId}`)?.scrollIntoView({
                    behavior: "smooth",
                });
            }}
        >
            <Grid item>
                <Typography
                    sx={{
                        fontSize: "14px",
                        fontWeight: 600,
                        color: "#6B7280",
                    }}
                >
                    {props.title}
                </Typography>
            </Grid>
            <Grid item>
                <Typography
                    sx={(theme) => ({
                        color: theme.palette.gray[700],
                        fontSize: "20px",
                        fontWeight: 600,
                    })}
                >
                    {props.count}
                </Typography>
            </Grid>
        </Grid>
    );
}
